"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUpdateAttributesExtension = void 0;
const index_js_1 = require("../../../../../entity/actions/update/symbols/index.js");
const number_js_1 = require("../../../../../entity/actions/update/updateItemParams/extension/number.js");
const reference_js_1 = require("../../../../../entity/actions/update/updateItemParams/extension/reference.js");
const set_js_1 = require("../../../../../entity/actions/update/updateItemParams/extension/set.js");
const index_js_2 = require("../../../../../errors/index.js");
const list_js_1 = require("./list.js");
const map_js_1 = require("./map.js");
const record_js_1 = require("./record.js");
const parseUpdateAttributesExtension = (attribute, input, options = {}) => {
    const { transform = true } = options;
    if ((0, index_js_1.isRemoval)(input)) {
        return {
            isExtension: true,
            *extensionParser() {
                const { path, required } = attribute;
                if (required !== 'never') {
                    throw new index_js_2.DynamoDBToolboxError('parsing.attributeRequired', {
                        message: `Attribute ${path !== undefined ? `'${path}' ` : ''}is required and cannot be removed`,
                        path
                    });
                }
                const parsedValue = input;
                if (transform) {
                    yield parsedValue;
                }
                else {
                    return parsedValue;
                }
                const transformedValue = input;
                return transformedValue;
            }
        };
    }
    if ((0, index_js_1.isGetting)(input)) {
        return (0, reference_js_1.parseReferenceExtension)(attribute, input, options);
    }
    switch (attribute.type) {
        case 'number':
            return (0, number_js_1.parseNumberExtension)(attribute, input, options);
        case 'set':
            return (0, set_js_1.parseSetExtension)(attribute, input, options);
        case 'list':
            return (0, list_js_1.parseListExtension)(attribute, input, options);
        case 'map':
            return (0, map_js_1.parseMapExtension)(attribute, input, options);
        case 'record':
            return (0, record_js_1.parseRecordExtension)(attribute, input, options);
        default:
            return {
                isExtension: false,
                basicInput: input
            };
    }
};
exports.parseUpdateAttributesExtension = parseUpdateAttributesExtension;
